var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-import-campaign-status"},[(_vm.statusData.tooltip)?_c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:({
      placement: 'bottom',
      arrow: true,
      arrowType: 'round',
      offset: '0, 0'
    }),expression:"{\n      placement: 'bottom',\n      arrow: true,\n      arrowType: 'round',\n      offset: '0, 0'\n    }"}],class:_vm.classStatusIcon,attrs:{"content":!!_vm.statusData.tooltip ? _vm.statusData.tooltip : undefined}},[_vm._v("\n    "+_vm._s(_vm.fallBackDescription)+"\n  ")]):_c('span',{class:_vm.classStatusIcon},[_vm._v("\n    "+_vm._s(_vm.fallBackDescription)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }